import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-card-avvisi',
  templateUrl: './sample-card-avvisi.component.html',
  styleUrls: ['./sample-card-avvisi.component.scss']
})
export class SampleCardAvvisiComponent implements OnInit {

  @Input() block: any;
  @Input() isAvvisi: boolean = false;
  public isLinkEsternal: boolean = false;
  public labelCategorySmall = "";

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.setTitle(this.block.field_titolo) ? this.nodeService.verifyLinkExternal(this.setTitle(this.block.field_titolo).link) : false;
    if(this.block && this.block.field_tassonomia_area_universita) {
      this.setLabelCategorySmall(this.block.field_tassonomia_area_universita);
    }
  }

  public setLabelCategorySmall(category: any) {
    let stingCategory: string = '';
    if (category.length > 3) {
      stingCategory = category[0].name + ', ' + category[1].name + ', ' + category[2].name + ', ' + '+' + (category.length - 3);
    } else {
      category.forEach((el: any, idx: number) => {
        if (idx === category.length - 1) {
          stingCategory += el.name;
        } else {
          stingCategory += el.name + ', ';
        }
      });
    }
    this.labelCategorySmall = stingCategory;
  }

  public setTitle(field_titolo: string): any {
    return this.nodeService.retriveLinkTagA(field_titolo, 'a');
  }

}
